

























































import Vue from 'vue';
import StatsService from '@/api/stats.service';
import EventBus from '@/helpers/event-bus';
import { reactivationCampaignOutcomeMap, LOAD_STATE } from '@/store/shared';
import { IReactivationStats, ISession, LoadState, IDunningCampaignCount } from '@/store/types';
import { formatPercent, formatSmallMoney, formatSmallNumber } from '@/helpers/jsUtils';
import { shortTimeAgoExtended } from '@/helpers/date-utils';
import OverallLoader from '@/components/UI/Loader/OverallLoader.vue';
import HeaderLoader from '@/components/UI/Loader/HeaderLoader.vue';
import { mapGetters, mapState } from 'vuex';
import { timeDay } from 'd3';

export default Vue.extend({
  name: 'OvervallPerformance',
  components: {
    HeaderLoader,
    OverallLoader,
  },
  data() {
    return {
      reactivationRates: null as IReactivationStats | null,
      loadState: LOAD_STATE.LOADING as LoadState,
      LOAD_STATE,
      formatSmallMoney,
      formatPercent,
      formatSmallNumber,
      shortTimeAgoExtended,
      activeCampaignCount: 0,
      activeCampaignAmount: 0,
      emailsSent: 0,
      emailsScheduled: 0,
      emailsClicked: 0,
      emailsOpened: 0,
      emailOpenRate: 0,
      recentEmailDate: undefined as undefined | Date,
      recentEmailName: '',
      outcomeBreakdown: {} as { [key: string]: number },
      reactivationCampaignOutcomeMap,
    };
  },
  async created() {
    try {
      const dateLastWeek = timeDay.floor(timeDay.offset(new Date(), -7));
      const [activeCampaigns, emailStates, recentEmail] = await Promise.all([
        StatsService.reactivationCampaignCountLive({
          filter: { active: true },
        }),
        StatsService.reactivationEmailCount({
          filter: { startDate: dateLastWeek },
          breakdown: ['status'],
        }),
        StatsService.filteredReactivationEmails({
          filter: { startDate: new Date() },
          options: {
            sort: '-openedAt',
            limit: 1,
          },
        }),
      ]);
      if (activeCampaigns.length === 1) {
        this.activeCampaignCount = activeCampaigns[0].count;
      }
      if (emailStates.length) {
        const sent = emailStates.find((s) => s.status === 'sent')?.count || 0;
        const delivered = emailStates.find((s) => s.status === 'delivered')?.count || 0;
        const clicked = emailStates.find((s) => s.status === 'clicked')?.count || 0;
        const opened = emailStates.find((s) => s.status === 'opened')?.count || 0;

        this.emailsSent = sent + clicked + opened + delivered;
        this.emailsOpened = opened + clicked;
        this.emailsClicked = clicked;

        this.emailOpenRate = this.emailsSent ? this.emailsOpened / this.emailsSent : 0;

        this.emailsScheduled = emailStates.find((s) => s.status === 'scheduled')?.count || 0;
      }
      if (recentEmail.length === 1) {
        this.recentEmailDate = recentEmail[0].sendDate;
        this.recentEmailName = recentEmail[0].emailTo;
      }
      this.loadState = LOAD_STATE.LOADED;
    } catch (e) {
      console.log(e);
      this.loadState = LOAD_STATE.ERROR_LOADING;
    }
  },
  computed: {
    ...mapGetters(['lowData', 'daysSinceOrgCreated', 'confidential']),
    sessions(): ISession[] {
      return this.$store.state.recentSessions;
    },
    loading(): boolean {
      return this.$store.state.recentSessionsLoadState !== LOAD_STATE.LOADED;
    },
    lowVolume(): boolean {
      return this.lowData || this.daysSinceOrgCreated < 45;
    },
  },
});
